import AboutWhoWeAreSection from "../../Organisms/AboutWhoWeAreSection/AboutWhoWeAreSection";
import AboutOurTeamSection from "../../Organisms/AboutOurTeamSection/AboutOurTeamSection";
import LogosSection from "../../Organisms/LogosSection/LogosSection";
import CenteredHeader from "../../Molecules/CenteredHeader/CenteredHeader";
import ReactSlider from "../../Organisms/ReactSlider/ReactSlider";
import "./About.scss";
import content from "./content";
// import ChangeableHeader from "../../Molecules/ChangeableHeader/ChangeableHeader";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

export const About = () => {
	const { dropdownHeader } = useScrollCtx();
	const {language} = useLanguageCtx();

	return (
		<>
			<ChangeableHeaderV2
				appearSecondNavbar={dropdownHeader}
				titleBanner={content[language].titleBanner}
				spanTitleYellow={content[language].titleYellowBanner}
			/>
			<AboutWhoWeAreSection />
			<AboutOurTeamSection />
			<div className="about-centeredHeader-container top-space-section about">
				<CenteredHeader
					yellowText={content[language].testimoniosYellowTitle}
					boldText={content[language].testimoniosBoldText}
					route="about"
				/>
			</div>
			<LogosSection route="about" />
			<ReactSlider />
		</>
	);
};
